module.exports = __webpack_public_path__ + "static/retriever-2dac0161f07819a30cc1f3997d28f8db.png";